__turbopack_context__.v({
  "className": "open_sans_9fd022ab-module__DBp_uG__className",
  "variable": "open_sans_9fd022ab-module__DBp_uG__variable",
});
